import React from 'react';

class OperatorsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelection = this.handleSelection.bind(this);
  }

  handleSelection(e) {
    //sends operator
    this.props.setInputType(e.target.value);
  }

  render() {
    const { operator, data } = this.props;
    return (
      <select
        className="Rule-select"
        value={operator !== null ? operator : ''}
        onChange={this.handleSelection}
        aria-label={t('smart_groups.create_modal.select_operator')}
      >
        <option disabled value="">
          {t('smart_groups.create_modal.select_operator')}
        </option>
        {Object.keys(data).map(operatorKey => (
          <option key={operatorKey} value={operatorKey}>
            {data[operatorKey]}
          </option>
        ))}
      </select>
    );
  }
}

export default OperatorsDropdown;
